import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";
//----------------------------------------------------

// POST =>  add SectionToClass
export const addSectionToClass = createAsyncThunk(
  "section/addSectionToClass",
  async (data, thunkAPI) => {
    console.log(data);
    try {
      const response = await axios.post(URLS.addSectionToClassURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET => getSectionsForClass
export const getSectionsForClass = createAsyncThunk(
  "section/getSectionsForClass",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(
        `${URLS.getSectionsForClassURL}/${params?.classId}/${params?.schoolId}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET => editSection
export const editSection = createAsyncThunk(
  "section/editSection",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.editSectionURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET => getPointsForSectionStudents
export const getPointsForSectionStudents = createAsyncThunk(
  "section/getPointsForSectionStudents",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getPointsForSectionStudentsURL, {
        params: {
          section_id: params?.section_id,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET => getTestGradesForSection
export const getTestGradesForSection = createAsyncThunk(
  "section/getTestGradesForSection",
  async (section_id, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getTestGradesForSectionURL, {
        params: {
          section_id: section_id,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  show results
export const showResults = createAsyncThunk(
  "section/showResults",
  async (params, thunkAPI) => {
    console.log("params", params);
    try {
      const response = await axios.get(URLS.getJalaaURL, {
        params: {
          student_id: params?.student_id,
          last_season: params?.last_season,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
